export enum StateStatus {
    initial = 'initial',
    loading = 'loading',
    success = 'success',
    failure = 'failure'
}
